<template>
	<div class="box vh-140">
		<div class="box-header">
			<i class="fa fa-th-large"></i>
			<h3 class="box-title">资源列表</h3>
			<div class="box-tools">
				<el-button type="primary" size="small" class="pull-right" @click="toEditRes()" round><i class="fa fa-plus"></i> 添加资源 </el-button>
			</div>
		</div>
		<div class="box-body">
			<el-table ref="multipleTable" :data="resTreeList" border tooltip-effect="dark" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
				<template slot="empty">
					<div class="no-data">暂无数据！</div>
				</template>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" label="名称" width="250" :formatter="formatTab"></el-table-column>
				<el-table-column prop="flag" label="标识符" width="180"></el-table-column>
				<el-table-column prop="url" label="URL地址" width="280"></el-table-column>
				<el-table-column prop="type" label="类型" width="120" :formatter="formatType"></el-table-column>
				<el-table-column prop="weight" label="权重"></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="130">
					<template slot-scope="scope">
						<el-button @click.prevent="toEditRes(scope.row.id)" type="text" size="small"><i class="fa fa-edit"></i> 编辑 </el-button>
						<el-button @click.prevent="deleteRes(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除 </el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

    <el-dialog :title="isEdit ? '编辑' : '添加'" :visible.sync="dialogVisible" :destroy-on-close="true" width="550px" class="form-dialog">
      <el-form :model="resFm" :rules="rules" ref="resFm" size="small" label-width="80px">
        <el-form-item label="上级" prop="parentId">
          <el-cascader :options="options" :props="props" change-on-select v-model="parentIdEcho" style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="resFm.type" @change="onChange">
            <el-radio :label="1" chexked>菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
            <el-radio :label="3">portlet</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="resFm.name" placeholder="请输入资源名称"></el-input>
        </el-form-item>
        <el-form-item label="标识符" prop="flag">
          <el-input v-model="resFm.flag" placeholder="请输入资源标识符"></el-input>
        </el-form-item>
        <el-form-item label="URL地址" prop="url">
          <el-input v-model="resFm.url" placeholder="请输入资源地址"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon" v-show="resFm.type !== 2">
          <el-input v-model="resFm.icon" placeholder="请输入资源地址"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight" v-show="resFm.type !== 2">
          <el-input v-model="resFm.weight" placeholder="请输入权重"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="resFm.description" placeholder="请输入资源描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="doClose()" size="small" round><i class="fa fa-close"></i> 关闭 </el-button>
        <el-button type="primary" @click="saveRes()" size="small" round><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import { get, save, update, tree, fetchList, remove } from '@/api/system/resource'
import { handleConfirm } from '@utils/confirm'

export default {
	created() {
		this.fetchData()
	},
  data() {
    return {
      resTreeList: [],
      options: [],
      isEdit:false,
      dialogVisible:false,
      props: {
        value: 'id',
        label: 'name',
        children: 'childrens'
      },
      parentIdEcho: [0],
      resFm: {
        type: 1,
        resource: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入资源名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        resource: [{ required: true, message: '请选择上级资源', trigger: 'blur' }],
        flag: [{ required: true, message: '请输入标识符', trigger: 'blur' }]
      }
    }
  },
	methods: {
		fetchData() {
			fetchList().then(resp => {
				this.resTreeList = resp.data.result
			})
		},
		formatTab(row, column, val) {
			let prefix = []
			if (row.parentIds && row.parentIds !== '0') {
				let preLength = row.parentIds.split(',').length
				prefix = Array(preLength === 0 ? 1 : preLength).fill('　')
			}
			return prefix.join('') + '├ ' + val
		},
		formatType: function(row, column, val) {
			return val === 1 ? '菜单' : val === 2 ? '按钮' : val === 3 ? 'portlet' : ''
		},
		toEditRes(val) {
      this.getTree()
      this.dialogVisible = true
      if (val) {
        this.isEdit = true
        get(val).then(resp => {
          this.resFm = resp.data.result
          this.parentIdEcho = this.resFm.parentIds.split(',').map(h => {
            return +h
          })
        })
      } else {
        this.isEdit = false
        this.resFm = { type: 1 }
        this.parentIdEcho = [0]
      }
    },
		deleteRes(val) {
      handleConfirm('此操作将永久删除该资源, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
		},
    saveRes() {
      this.$refs['resFm'].validate(valid => {
        if (valid) {
          this.resFm.parentId = this.parentIdEcho[this.parentIdEcho.length - 1]
          this.resFm.parentIds = this.parentIdEcho.join(',')

          if (this.isEdit) {
            update(this.resFm).then(resp => {
              this.submitCallback(resp)
            })
          } else {
            save(this.resFm).then(resp => {
              this.submitCallback(resp)
            })
          }
        }
      })
    },
    submitCallback(resp) {
      if (resp.status === 200) {
        this.$message.success(resp.data.message)
        this.dialogVisible = false
        this.fetchData()
      }
    },
    getTree() {
      tree().then(resp => {
        this.options = resp.data.result
        this.options.push({ name: '根节点', id: 0 })
      })
    },
    doClose() {
      this.dialogVisible = false
    },
    onChange(val) {
      this.resFm.type = val
    }
	}

}
</script>
